var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon loading"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.success === undefined)?_c('span',{key:"ldg-1",staticClass:"loading__active"},[_vm._v("f")]):(_vm.success)?_c('span',{key:"ldg-2",staticClass:"loading__done"},[_vm._v("W")]):_c('span',{key:"ldg-2",staticClass:"loading__error"},[_vm._v("g")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }